import { render, staticRenderFns } from "./PriceEdit.vue?vue&type=template&id=7202ab4c&scoped=true&"
import script from "./PriceEdit.vue?vue&type=script&lang=js&"
export * from "./PriceEdit.vue?vue&type=script&lang=js&"
import style0 from "./PriceEdit.vue?vue&type=style&index=0&id=7202ab4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7202ab4c",
  null
  
)

export default component.exports